<div class="card-project investment-card card-fade-in">
    <div class="header-card text-center align-content-center">
        <p class="fs-18 fw-bold mb-1 mt-3">{{ devName }}</p>
        <p class="fs-12 mb-3"><img class="me-2" src="/assets/img/icon/location-icon.svg"
                alt="location-icon">{{dev?.d?.city?.name}} - 
                {{ dev?.d?.name.includes('Casa') && dev?.d?.actualState == 'variable' ? 'Casa:' :
              'Campaña:' }} {{ actualPhase }}
            </p>
    </div>
    <div class="ribbon text-center align-content-center">
        <p class="cl-white fs-14 mb-0">{{ getProjectStateText(this.dev?.d?.state || this.dev?.actualState) }}</p>
    </div>

    <img [routerLink]="[pathV2, dev?.d?.pid]" class="img-card" [src]="buildImageUrl(dev, urlBaseS3)" alt="..">
    <div class="bg-line w-100 m-auto">
        <div class="bg-process" [style.width.%]="progress"
            [ngClass]="dev?.d?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'"></div>
        <div class="text-line-process d-flex justify-content-between">
            <p class="pe-3 percent-span">{{ message}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-between bg-white px-4">
        <p class="cl-black fs-13 mb-0">Monto conseguido</p>
        <p class="cl-black fs-13 mb-0">{{ ( dev?.p?.active * 1000 ) | currency:'$': 'symbol' : '.0-0'}}</p>
    </div>
    <div class="content-card pb-3 pb-lg-0 px-4 mb-2">
        <div class="d-flex justify-content-between mt-3 mb-1">
            <p class="cl-black mb-0 fs-14">{{ dev?.d?.state == 'fixed' ? 'Rendimiento anual fijo:': 'TIR anualestimada:' }}</p>
            <p class="cl-primary mb-0 fs-14 fw-sbold text-end">{{ dev?.d?.state == 'fixed' ? dev?.d?.performance : dev?.d?.estimatedPerformance | number }}%</p>
        </div>
        <div class="d-flex justify-content-between mb-1">
            <p class="cl-black mb-0 fs-14">{{ dev?.d?.state == 'fixed' ? 'Plazo:' : 'Plazo estimado:' }}</p>
            <p class="cl-primary mb-0 fs-14 fw-sbold">{{ dev?.d?.intervalMonthsResidential || dev?.d?.monthsEstimateResidential }}</p>
        </div>
        <div class="d-flex justify-content-between mb-1">
            <p class="cl-black mb-0 fs-14">Invierte desde: </p>
            <p class="cl-primary mb-0 fs-14 fw-sbold">${{ dev?.p?.partValue | number }} </p>
        </div>

        @if(dev?.p?.free >= 1){
        <div class="mt-3 text-center">
            <p class="fs-14 fw-bold">{{ textDateToInvest }}</p>
        </div>
        }
        <div class="div-btn mt-2">
            <button class="btn btn-hover cl-white bg-primary" [routerLink]="[pathV2, dev?.d?.pid]">
                Quiero invertir
            </button>
        </div>
    </div>
</div>